import { render, staticRenderFns } from "./CourseStepOfDy.vue?vue&type=template&id=6c396596&scoped=true&"
import script from "./CourseStepOfDy.vue?vue&type=script&lang=js&"
export * from "./CourseStepOfDy.vue?vue&type=script&lang=js&"
import style0 from "./CourseStepOfDy.vue?vue&type=style&index=0&id=6c396596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c396596",
  null
  
)

export default component.exports